var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Badge',{staticClass:"mr-2"},[_c('span',{staticClass:"mr-1"},[_vm._v(_vm._s(_vm.attributeValue.attribute.caption)+":")]),_vm._v(" "+_vm._s(_vm.attributeValue.caption)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }